import { $form, $view } from 'signals/global.signals';
import { handleHideModal } from 'components/global/_helpers/global.helpers';
import UniversalInput from 'components/global/UniversalInput';
import SimpleModal from 'components/global/SimpleModal';
import { handleSubmitSendInvite } from 'components/views/InvestorTeam/_helpers/investorTeam.events';

const InviteUserModal = () => (
  <SimpleModal
    show={$view.value.activeModal === 'invite-user'}
    title="Invite User"
    primaryButtonText="Send Invite"
    secondaryButtonText="Cancel"
    onHide={handleHideModal}
    onPrimaryClick={handleSubmitSendInvite}
    onSecondaryClick={handleHideModal}
    isLoading={$view.value.isModalLoading}
  >
    <UniversalInput
      label="Email"
      name="email"
      type="email"
      value={$form.value.email}
    />
  </SimpleModal>
);

export default InviteUserModal;
